import { ReactNode } from "react";
import { StyledDarkOverlay } from "./DarkOverlay.styled";
import { XIcon } from "@phosphor-icons/react";
import { Box } from "@mui/material";

type DarkOverlayProps = {
  opened: boolean;
  component: ReactNode;
  onClose?: () => void;
};

export const DarkOverlay = ({
  opened,
  component,
  onClose,
}: DarkOverlayProps) => {
  if (!opened) return <></>;

  return (
    <StyledDarkOverlay>
      <Box className="componentWrapper">
        {component}
        {onClose && (
          <XIcon
            size={48}
            onClick={onClose}
            className="closeBtn"
            weight="bold"
          />
        )}
      </Box>
    </StyledDarkOverlay>
  );
};
